import { ApolloClient, HttpLink, InMemoryCache, from } from '@apollo/client';
import { onError } from '@apollo/client/link/error';
export function createClient(shopDomain, apiToken) {
  var apiVersion = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '2023-10';
  var errorLink = onError(function (_ref) {
    var graphQLErrors = _ref.graphQLErrors,
        networkError = _ref.networkError;

    if (graphQLErrors) {
      graphQLErrors.forEach(function (_ref2) {
        var message = _ref2.message,
            extensions = _ref2.extensions,
            locations = _ref2.locations,
            path = _ref2.path;
        console.error("[GraphQL error]: ".concat(message), {
          extensions: extensions,
          locations: locations,
          path: path
        });
      });
    }

    if (networkError) {
      console.error('Network error', {
        networkError: networkError
      });
    }
  });
  var httpLink = new HttpLink({
    fetch: window.fetch,
    uri: "https://".concat(shopDomain, "/api/").concat(apiVersion, "/graphql.json"),
    headers: {
      'X-Shopify-Storefront-Access-Token': apiToken,
      Accept: 'application/json'
    }
  });
  var cache = new InMemoryCache();
  return new ApolloClient({
    cache: cache,
    link: from([errorLink, httpLink]),
    defaultOptions: {
      query: {
        errorPolicy: 'all'
      }
    }
  });
}